module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C841"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/html/52_Notes#id_14",
      "id": "page_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TABLET")])])]), _vm._v(" "), _c('p', {
    staticClass: "C852"
  }, [_vm._v("Up the cutbank of a creek named after stone,")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("striking stone, I came walking, my fingers")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("stained with the pulp of raspberries picked")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("from branches arched over descending snowmelt")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("beneath two clouds and blue sky no one")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("built. Napped between that extravagant")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("quilt and sunwarmed sand until the taut line")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("woke me, tugging in my palm. The trout’s")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("eye was a polished nickel poleaxed")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("by a drop of ink, though I am writing this")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("in the brown juice spit from a grasshopper’s lips,")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("instinct having made for many a miracle")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("such as this emergent mayfly shaking its wings")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("dry, to whom I whisper—Go light and soft")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("with this pittance, straight to the lord")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("whose commandments are writ in water.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6206e22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/07_Tablet.vue
// module id = 75
// module chunks = 0